export const groupByEnum = {
  NONE: 'NONE',
  SCHEME: 'SCHEME',
  GROUP_ONE_LEVEL: 'GROUP_ONE_LEVEL',
  GROUP_ALL: 'GROUP_ALL',
} as const

export type GroupByEnum = (typeof groupByEnum)[keyof typeof groupByEnum]

export type GroupBy = GroupByEnum